import { useEffect, useMemo, useState } from "react";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";
import { csvHeaderVvlp, vlpHeader, vlpHidden } from "../Tabellen/ConstTabKopf/VvLinieProdKopf";
import GeneralTable from "../Tabellen/GeneralTable";
import DatenLaden from "../Tabellen/DatenLaden";
import VlpUpdate from "./VlpUpdate";
import VlpCreate from "./VlpCreate";
import InformationCell from "../Tabellen/InformationCell";
import { VvLinieProduktFilter } from "./VvLinieProdFilter";
import { CompleteFilter, FilterAction, FilterDates, FilterDatesInput } from "../StyleSheets/VvLinieProduktFilterStyle";
import StammdatenExport from "../Stammdaten/StammdatenExport";

var MonitorApi = require('monitor-api');


export default function VvLinieProdukt({ vvInstance, linieInstance, prodInstance, vvLinProdInstance, goBack, setTable }) {
    const [tableData, setTableData] = useState(null);

    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    const [reload, setReload] = useState(false);

    const [vvList, setVvList] = useState([]);
    const [vvShow, setVvShow] = useState(false);
    const [vvTextSearch, setVvTextSearch] = useState("");
    const [vvCheckboxes, setVvCheckboxes] = useState([]);
    const [vvChooseAll, setVvChooseAll] = useState(true);

    const [linieList, setLinieList] = useState([]);
    const [linieShow, setLinieShow] = useState(false);
    const [linieTextSearch, setLinieTextSearch] = useState("");
    const [linieCheckboxes, setLinieCheckboxes] = useState([]);
    const [linieChooseAll, setLinieChooseAll] = useState(true);

    const [prodList, setProdList] = useState([]);
    const [prodShow, setProdShow] = useState(false);
    const [prodTextSearch, setProdTextSearch] = useState("");
    const [prodCheckboxes, setProdCheckboxes] = useState([]);
    const [prodChooseAll, setProdChooseAll] = useState(true);

    const reloadData = () => {
        setTableData();
        setReload(false);
        let loading = new Promise((result) => {
            vvLinProdInstance.getCompleteVertraglinieprodukt((error, data, response) => {
                if (error) {
                    console.error(error);
                    FehlerauswertungErrResp(error, response);
                } else {
                    data.forEach(element => {
                        element.gueltigVon = element.gueltigVon.toLocaleDateString();
                        if (element.gueltigBis) {
                            element.gueltigBis = element.gueltigBis.toLocaleDateString();
                        }
                    });
                    result(data);
                }
            });
        })
        loading.then(d => setTableData(d));
    }

    const loadWithFilter = (event) => {
        event.preventDefault();
        var myFilter = new MonitorApi.VertragLinieProduktFilter();

        var filterVv = Object.keys(vvCheckboxes).filter(it => vvCheckboxes[it]).map(it => parseInt(it));
        var filterLinie = Object.keys(linieCheckboxes).filter(it => linieCheckboxes[it]).map(it => parseInt(it));
        var filterProd = Object.keys(prodCheckboxes).filter(it => prodCheckboxes[it]).map(it => parseInt(it));

        myFilter.idsVertrag = filterVv.length > 0 ? filterVv : undefined;
        myFilter.idsLinie = filterLinie.length > 0 ? filterLinie : undefined;
        myFilter.idsProdukt = filterProd.length > 0 ? filterProd : undefined;
        myFilter.startDate = startDate;
        myFilter.endDate = endDate;

        console.log("filter:", myFilter)

        let loading = new Promise((result) => {
            console.log("filter: ", myFilter);
            vvLinProdInstance.patchFilteredVertraglinieprodukt(myFilter, (error, data, response) => {
                if (error) {
                    console.error(error);
                    FehlerauswertungErrResp(error, response);
                } else {
                    data.forEach(element => {
                        element.gueltigVon = element.gueltigVon.toLocaleDateString();
                        if (element.gueltigBis) {
                            element.gueltigBis = element.gueltigBis.toLocaleDateString();
                        }
                    });
                    result(data);
                }
            });
        })
        loading.then(d => {
            setTableData(d);
            setReload(false);
        });
    }

    useEffect(() => {
        vvLinProdInstance.getCompleteVertraglinieprodukt((error, data, response) => {
            if (error) {
                console.error(error);
                FehlerauswertungErrResp(error, response);
            } else {
                data.forEach(element => {
                    element.gueltigVon = element.gueltigVon.toLocaleDateString();
                    if (element.gueltigBis) {
                        element.gueltigBis = element.gueltigBis.toLocaleDateString();
                    }
                });
                setTableData(data);
            }
        });

        vvInstance.getListVerkehrsvertragVerkehrsvertragListGet((error, data) => {
            if (error) {
                console.error(error);
            } else {
                console.log('load vvliste')
                setVvList(data);
                data.map(d => setVvCheckboxes(pre => ({ ...pre, [d.id]: true })));
            }
        });

        linieInstance.getListedLinienLinienlisteGet((error, data) => {
            if (error) {
                console.log('error', error);
            } else {
                console.log('load linienliste', data);
                setLinieList(data);
                data.map(d => setLinieCheckboxes(pre => ({ ...pre, [d.id]: true })))
            }
        });

        prodInstance.getListProdukte((error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log('load prodliste', data);
                setProdList(data);
                data.map(d => setProdCheckboxes(pre => ({ ...pre, [d.id]: true })))
            }
        });

    }, [vvLinProdInstance, vvInstance, linieInstance, prodInstance])


    const setStart = event => {
        setReload(true);
        setStartDate(event.target.value);
    }

    const setEnd = event => {
        setReload(true);
        setEndDate(event.target.value);
    }

    const prepData = useMemo(() => tableData, [tableData]);
    const updateCol = {
        id: "update",
        Header: "",
        keyword: "Änderungen",
        Cell: ({ row }) => (
            <div>
                <VlpUpdate rowEntry={row} reloadData={reloadData} vlpInstance={vvLinProdInstance} />
            </div>
        )
    }
    const commCol = {
        id: "comment",
        Header: "",
        keyword: "Info",
        Cell: ({ row }) => (
            <div>
                <InformationCell comment={row.original.kommentar} />
            </div>
        )
    }

    const csvIt = loadedData => {
        return loadedData.map(it =>
        ({
            ...it,
            'Verkehrsvertrag': it.vv,
            'Linie': it.linie,
            'Produkt': it.produkt,
            'Gültigkeitsbeginn': it.gueltigVon,
            'Gültigkeitsende': it.gueltigBis,
            'Kommentar': it.kommentar
        }))
    }

    return (<>
        <div>
            <h4>Filteroptionen:</h4>
            <CompleteFilter>
                <VvLinieProduktFilter
                    placeholder={"---Verkehrsvertrag---"}
                    show={vvShow} setShow={setVvShow}
                    textSearch={vvTextSearch} setTextSearch={setVvTextSearch}
                    chooseAll={vvChooseAll} setChooseAll={setVvChooseAll}
                    checkboxes={vvCheckboxes} setCheckboxes={setVvCheckboxes}
                    list={vvList} attribut={"vertrag"} setReload={setReload} />

                <VvLinieProduktFilter
                    placeholder={"---Linie---"}
                    show={linieShow} setShow={setLinieShow}
                    textSearch={linieTextSearch} setTextSearch={setLinieTextSearch}
                    chooseAll={linieChooseAll} setChooseAll={setLinieChooseAll}
                    checkboxes={linieCheckboxes} setCheckboxes={setLinieCheckboxes}
                    list={linieList} attribut={"linie"} setReload={setReload} />

                <VvLinieProduktFilter
                    placeholder={"---Produkt---"}
                    show={prodShow} setShow={setProdShow}
                    textSearch={prodTextSearch} setTextSearch={setProdTextSearch}
                    chooseAll={prodChooseAll} setChooseAll={setProdChooseAll}
                    checkboxes={prodCheckboxes} setCheckboxes={setProdCheckboxes}
                    list={prodList} attribut={"produkt"} setReload={setReload} />
            </CompleteFilter>

            <FilterDates>
                <label htmlFor="startDate">von:</label>
                <FilterDatesInput id="startDate" type="date" onChange={setStart} min={'2000-01-01'} />

                <label htmlFor="endDate">bis:</label>
                <FilterDatesInput id="endDate" type="date" onChange={setEnd} min={startDate ? startDate : '2000-01-01'} />
            </FilterDates>

            <FilterAction disabled={!reload} onClick={loadWithFilter}>Daten filtern</FilterAction>
        </div>

        <div>
            <VlpCreate vvList={vvList} linieList={linieList} prodList={prodList} vvLinProdInstance={vvLinProdInstance} reloadData={reloadData} />
        </div>

        <div>
            {tableData
                ? <div>
                    <GeneralTable data={prepData} columns={vlpHeader} hiddenColumns={vlpHidden} additionalColumns={[commCol, updateCol]} reloadData={reloadData} />
                    <StammdatenExport csvedData={csvIt(prepData)} csvHeader={csvHeaderVvlp} csvFilename={"sd_vv_l_p"} />
                </div>
                : <DatenLaden />}
        </div>
    </>);
}